import OptimizerEditDto from "./OptimizerEditDto";

export class NelderMeadOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.xatol = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.fatol = null;
        /** @type {Boolean} */
        this.adaptive = null;
    }

    /**
     * @typedef {Object} _NelderMeadOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} xatol
     * @property {number} tol
     * @property {number} fatol
     * @property {Boolean} adaptive
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _NelderMeadOptimizerEditDtoProps} NelderMeadOptimizerEditDtoProps
     */
    /**
     * 
     * @param {NelderMeadOptimizerEditDtoProps} props
     * @returns {NelderMeadOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.xatol = props.xatol;
        this.tol = props.tol;
        this.fatol = props.fatol;
        this.adaptive = props.adaptive;
        return this;
    }
}

export default NelderMeadOptimizerEditDto;